import FAQAPI from 'api/FAQApi';

export const getFAQ = () => {
  return(dispatch: any) => {
    return FAQAPI.getFAQ().then((res) => {
      dispatch(setCategories(res.data.categories))
    })
  }
}

export const setCategories = (categories: any) => {
  return { type: 'FETCH_FAQ', payload: categories };
}



// WEBPACK FOOTER //
// ./src/actions/faq/faq.js